import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box, Link, } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import PlaceHolder from '../common/PlaceHolder';
import AssetImage from '../common/asset/AssetImage';
const Kicker = ({ kickerID, editData, limitToPageWidth, }) => {
    const { currentPortal: portal, getOrLoad } = useStore();
    if (!portal) {
        return null;
    }
    if (!kickerID) {
        if (editData) {
            return (_jsx(PlaceHolder, { placeHolderName: "Configure Portal Kicker Widget" }));
        }
        return null; // no course - silently skip the widget
        // return (<div>No featured course</div>);
        // @todo - when editing show placeholder
    }
    if (!kickerID) {
        return null;
    }
    const kicker = getOrLoad('kicker', kickerID);
    const { asset, link, openInNewTab, } = kicker;
    console.log('asset', asset, link, kickerID);
    return (_jsx(Box, { sx: {
            cursor: 'pointer',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx(Link, { href: link, target: openInNewTab ? '_blank' : '', rel: "noopener", children: _jsx(AssetImage, { asset: asset, customStyle: {
                    width: '100%',
                }, size: "thumb400w" }) }) }));
};
Kicker.defaultProps = {
    editData: undefined,
};
Kicker.meta = {
    group: 'display',
    name: 'Kicker',
    description: 'Component displays the kicker',
    props: [
        {
            key: 'kickerID',
            name: 'Kicker',
            type: 'kicker', // note this is a special type recognized by the system
            description: 'The ID of the portal kicker to display',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'KickerWidget',
        props: {
            kickerID: null,
            limitToPageWidth: true,
        },
    },
};
export default observer(Kicker);
//# sourceMappingURL=KickerWidget.js.map